import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import axios from "axios";
import { Link, NavLink, useOutletContext, useParams } from "react-router-dom";
import { currency_converter_inr } from "../../../utils/currencyUtils";
import { MaterialReactTable } from "material-react-table";
import { decodeHtml } from "../../../utils/decodeHtml";
import { colors } from "@mui/material";


function UnitPerformance() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const [data, setData] = useState([]);
  const [partnersOptions, setPartnersOptions] = useState([]);
  const [opPartnersOptions, setOpPartnersOptions] = useState([]);
  const [emOptions, setEmOptions] = useState([]);
  const [otherOptions, setOtherOptions] = useState([]);
  const { setGlobalLoading, token } = useOutletContext();
  const today = new Date();
  const currentFY =
      today.getMonth() + 1 >= 4
        ? `${today.getFullYear()}-${today.getFullYear() + 1}`
        : `${today.getFullYear() - 1}-${today.getFullYear()}`;
  
  const [selectedYear, setSelectedYear] = useState(currentFY);

  const formatNumber = (num) => {
    if (!num) return 0;
    return new Intl.NumberFormat("en-IN").format(num);
    };
  async function fetchOptions() {
    setGlobalLoading(true);
    try {
        const response = await axios.get(
        `${API_BASE_URL}/reports/get_unit_performance/`,
        {
            params: { year: selectedYear},
            headers: { Authorization: `Bearer ${token}` },
        }
        );
        setPartnersOptions(response.data.performance_partners || []);
        setOpPartnersOptions(response.data.performance_op_partners || []);
        setEmOptions(response.data.performance_em || []);
        setOtherOptions(response.data.performance_sc_c_a || []);
        const d = response.data;
        if (response.status === 200) {
            setData({
            ...d,
            });
        }
    } catch (error) {
        console.error("API Error:", error);
        // setoptions([]);
    } finally {
        setGlobalLoading(false); 
    }
  }

useEffect(() => {
  if (token && selectedYear) {
    fetchOptions();
  }
}, [token, selectedYear]); 

  const financialYears = Array.from({ length: 4 }, (_, i) => {
  const start = new Date().getFullYear() - i;
  const end = start + 1;
    return {
      label: `${start}-${end}`,
      value: `${start}-${end}`,
    };
  });  

    return (
        <>
        <style>
        {`
        .table {
            font-size: 12px;
            margin-bottom: 0;
          }
          .table th,
          .table td {
            padding: 4px 8px !important;
            white-space: nowrap;
            vertical-align: middle;
            line-height: 1.2;
          }
          .table-responsive {
            overflow: auto;
            max-height: 500px;
          }
          /* Header */
          thead th {
            position: sticky;
            top: 0;
            background: #f5f5f5 !important;
            z-index: 20;
            font-weight: 600;
          }
          /* 1st column - Unit Head */
          .sticky-col-1 {
            position: sticky;
            left: 0;
            background: #fff;
            z-index: 15;
            min-width: 180px;
          }
          /* 2nd column - Generated / Net Add */
          .sticky-col-2 {
            position: sticky;
            left: 180px;
            background: #fff;
            z-index: 15;
            min-width: 100px;
          }
          /* 3rd column - Revenue Total */
          .sticky-col-3 {
            position: sticky;
            left: 280px;
            background: #fff;
            z-index: 15;
            min-width: 140px;
          }
          /* Sticky header + sticky columns */
          thead .sticky-col-1,
          thead .sticky-col-2,
          thead .sticky-col-3 {
            background: #f5f5f5 !important;
            z-index: 25;
          }
          /* Optional border */
          .sticky-col-1,
          .sticky-col-2,
          .sticky-col-3 {
            box-shadow: 1px 0 0 #ddd;
          }
        .chart-box {
              min-height: 250px; /* adjust as needed */
              display: flex;
              flex-direction: column;
          }    
        `}
        </style>  
        <div className="card shadow-sm">
            <div className="card-body justify-content-between">
                <div className="d-flex justify-content-between align-items-center mb-2 border-bottom pb-2">
                  <h4 className="mb-0">Partners Contribution</h4>
                <div style={{ width: "150px" }}>
                    <select
                    className="form-select"
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                    >
                    {financialYears.map((fy) => (
                        <option key={fy.value} value={fy.value}>
                        {fy.label}
                        </option>
                    ))}
                    </select>
                </div>
                </div>

                <div className="row">
                    <div className="col-md-12 col-xl-12 col-xxl-12">
                        <div className="table-responsive" style={{ maxHeight: "500px" }}>
                        <table className="table text-nowrap table-bordered">
                            <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                            <tr>
                                <th className="sticky-col-1"></th>
                                <th>Target</th>
                                <th>Business Generated</th>
                                <th>Business Delivered</th>
                                <th>Closed Searchesh</th>
                                <th>Active Roles</th>
                                <th>Active Clients</th>
                                <th>Self Delivered</th>
                                <th>Referred Business</th>
                            </tr>
                            </thead>

                            <tbody>
                            {partnersOptions.map((row, index) => (
                              <tr>
                                <td className="sticky-col-1">{row.bu_head}</td>
                                <td>{formatNumber(row.target)}</td>
                                <td>{formatNumber(row.business_generated)}</td>
                                <td>{formatNumber(row.revenue)}</td>
                                <td>{row.closed_searches}</td>
                                <td>{row.active_roles}</td>
                                <td>{row.active_clients}</td>
                                <td>{formatNumber(row.self_bd)}</td>
                                <td>{formatNumber(row.others_bd)}</td>
                              </tr>
                            ))}
                            </tbody>
                        </table>
                        </div>        
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12 col-xl-12 col-xxl-12">
                        <div class="card-title mt-3">Partners Revenue Contribution Breakup</div>
                        <div className="table-responsive" style={{ maxHeight: "500px" }}>
                        <table className="table text-nowrap table-bordered">
                            <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                            <tr>
                                <th className="sticky-col-1"></th>
                                <th className="sticky-col-2">Revenue</th>
                                <th>Q1</th>
                                <th>Q2</th>
                                <th>Q3</th>
                                <th>Q4</th>
                                <th>Apr</th>
                                <th>May</th>
                                <th>Jun</th>
                                <th>Jul</th>
                                <th>Aug</th>
                                <th>Sep</th>
                                <th>Oct</th>
                                <th>Nov</th>
                                <th>Dec</th>
                                <th>Jan</th>
                                <th>Feb</th>
                                <th>Mar</th>
                            </tr>
                            </thead>

                            <tbody>
                            {partnersOptions.map((row, index) => (
                              <tr>
                                <td className="sticky-col-1">{row.bu_head}</td>
                                <td className="sticky-col-2">{formatNumber(row.revenue)}</td>
                                <td>{formatNumber(row.Q1)}</td>
                                <td>{formatNumber(row.Q2)}</td>
                                <td>{formatNumber(row.Q3)}</td>
                                <td>{formatNumber(row.Q4)}</td>
                                <td>{formatNumber(row.Apr)}</td>
                                <td>{formatNumber(row.May)}</td>
                                <td>{formatNumber(row.Jun)}</td>
                                <td>{formatNumber(row.Jul)}</td>
                                <td>{formatNumber(row.Aug)}</td>
                                <td>{formatNumber(row.Sep)}</td>
                                <td>{formatNumber(row.Oct)}</td>
                                <td>{formatNumber(row.Nov)}</td>
                                <td>{formatNumber(row.Decr)}</td>
                                <td>{formatNumber(row.Jan)}</td>
                                <td>{formatNumber(row.Feb)}</td>
                                <td>{formatNumber(row.Mar)}</td>
                              </tr>
                            ))}
                            </tbody>
                        </table>
                        </div>        
                    </div>
                </div>

            </div>
        </div>
        <div className="card shadow-sm">
            <div className="card-body justify-content-between">
                <div className="d-flex justify-content-between align-items-center mb-2 border-bottom pb-2">
                  <h4 className="mb-0">Operating Partners Contribution</h4>
                </div>

                <div className="row">
                    <div className="col-md-12 col-xl-12 col-xxl-12">
                        <div className="table-responsive" style={{ maxHeight: "500px" }}>
                        <table className="table text-nowrap table-bordered">
                            <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                            <tr>
                                <th className="sticky-col-1"></th>
                                <th>Target</th>
                                <th>Business Generated</th>
                                <th>Business Delivered</th>
                                <th>Closed Searches</th>
                                <th>Active Roles</th>
                                <th>Active Clients</th>
                                {/* <th>Self Delivered</th> */}
                                <th>Referred Business</th>
                            </tr>
                            </thead>

                            <tbody>
                            {opPartnersOptions.map((row, index) => (
                              <tr>
                                <td className="sticky-col-1">{row.bu_head}</td>
                                <td>{formatNumber(row.target)}</td>
                                <td>{formatNumber(row.business_generated)}</td>
                                <td>{formatNumber(row.revenue)}</td>
                                <td>{row.closed_searches}</td>
                                <td>{row.active_roles}</td>
                                <td>{row.active_clients}</td>
                                {/* <td>{formatNumber(row.self_bd)}</td> */}
                                <td>{formatNumber(row.others_bd)}</td>
                              </tr>
                            ))}
                            </tbody>
                        </table>
                        </div>        
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12 col-xl-12 col-xxl-12">
                        <div class="card-title mt-3">Operating Partners Revenue Contribution Breakup</div>
                        <div className="table-responsive" style={{ maxHeight: "500px" }}>
                        <table className="table text-nowrap table-bordered">
                            <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                            <tr>
                                <th className="sticky-col-1"></th>
                                <th className="sticky-col-2">Revenue</th>
                                <th>Q1</th>
                                <th>Q2</th>
                                <th>Q3</th>
                                <th>Q4</th>
                                <th>Apr</th>
                                <th>May</th>
                                <th>Jun</th>
                                <th>Jul</th>
                                <th>Aug</th>
                                <th>Sep</th>
                                <th>Oct</th>
                                <th>Nov</th>
                                <th>Dec</th>
                                <th>Jan</th>
                                <th>Feb</th>
                                <th>Mar</th>
                            </tr>
                            </thead>

                            <tbody>
                            {opPartnersOptions.map((row, index) => (
                              <tr>
                                <td className="sticky-col-1">{row.bu_head}</td>
                                <td className="sticky-col-2">{formatNumber(row.revenue)}</td>
                                <td>{formatNumber(row.Q1)}</td>
                                <td>{formatNumber(row.Q2)}</td>
                                <td>{formatNumber(row.Q3)}</td>
                                <td>{formatNumber(row.Q4)}</td>
                                <td>{formatNumber(row.Apr)}</td>
                                <td>{formatNumber(row.May)}</td>
                                <td>{formatNumber(row.Jun)}</td>
                                <td>{formatNumber(row.Jul)}</td>
                                <td>{formatNumber(row.Aug)}</td>
                                <td>{formatNumber(row.Sep)}</td>
                                <td>{formatNumber(row.Oct)}</td>
                                <td>{formatNumber(row.Nov)}</td>
                                <td>{formatNumber(row.Decr)}</td>
                                <td>{formatNumber(row.Jan)}</td>
                                <td>{formatNumber(row.Feb)}</td>
                                <td>{formatNumber(row.Mar)}</td>
                              </tr>
                            ))}
                            </tbody>
                        </table>
                        </div>        
                    </div>
                </div>           

            </div>
        </div>
        <div className="card shadow-sm">
            <div className="card-body justify-content-between">
                <div className="d-flex justify-content-between align-items-center mb-2 border-bottom pb-2">
                  <h4 className="mb-0">EM Contribution</h4>
                </div>

                <div className="row">
                    <div className="col-md-12 col-xl-12 col-xxl-12">
                        <div className="table-responsive" style={{ maxHeight: "500px" }}>
                        <table className="table text-nowrap table-bordered">
                            <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                            <tr>
                                <th className="sticky-col-1"></th>
                                <th>Target</th>
                                <th>Business Generated</th>
                                <th>Business Delivered</th>
                                <th>Closed Searches</th>
                                <th>Active Roles</th>
                                <th>Active Clients</th>
                                {/* <th>Self Business</th> */}
                                <th>Referred Business</th>
                            </tr>
                            </thead>

                            <tbody>
                            {emOptions.map((row, index) => (
                              <tr>
                                <td className="sticky-col-1">{row.bu_head}</td>
                                <td>{formatNumber(row.target)}</td>
                                <td>{formatNumber(row.business_generated)}</td>
                                <td>{formatNumber(row.revenue)}</td>
                                <td>{row.closed_searches}</td>
                                <td>{row.active_roles}</td>
                                <td>{row.active_clients}</td>
                                {/* <td>{formatNumber(row.self_bd)}</td> */}
                                <td>{formatNumber(row.others_bd)}</td>
                              </tr>
                            ))}
                            </tbody>
                        </table>
                        </div>        
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12 col-xl-12 col-xxl-12">
                        <div class="card-title mt-3">EM Revenue Contribution Breakup</div>
                        <div className="table-responsive" style={{ maxHeight: "500px" }}>
                        <table className="table text-nowrap table-bordered">
                            <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                            <tr>
                                <th className="sticky-col-1"></th>
                                <th className="sticky-col-2">Revenue</th>
                                <th>Q1</th>
                                <th>Q2</th>
                                <th>Q3</th>
                                <th>Q4</th>
                                <th>Apr</th>
                                <th>May</th>
                                <th>Jun</th>
                                <th>Jul</th>
                                <th>Aug</th>
                                <th>Sep</th>
                                <th>Oct</th>
                                <th>Nov</th>
                                <th>Dec</th>
                                <th>Jan</th>
                                <th>Feb</th>
                                <th>Mar</th>
                            </tr>
                            </thead>

                            <tbody>
                            {emOptions.map((row, index) => (
                              <tr>
                                <td className="sticky-col-1">{row.bu_head}</td>
                                <td className="sticky-col-2">{formatNumber(row.revenue)}</td>
                                <td>{formatNumber(row.Q1)}</td>
                                <td>{formatNumber(row.Q2)}</td>
                                <td>{formatNumber(row.Q3)}</td>
                                <td>{formatNumber(row.Q4)}</td>
                                <td>{formatNumber(row.Apr)}</td>
                                <td>{formatNumber(row.May)}</td>
                                <td>{formatNumber(row.Jun)}</td>
                                <td>{formatNumber(row.Jul)}</td>
                                <td>{formatNumber(row.Aug)}</td>
                                <td>{formatNumber(row.Sep)}</td>
                                <td>{formatNumber(row.Oct)}</td>
                                <td>{formatNumber(row.Nov)}</td>
                                <td>{formatNumber(row.Decr)}</td>
                                <td>{formatNumber(row.Jan)}</td>
                                <td>{formatNumber(row.Feb)}</td>
                                <td>{formatNumber(row.Mar)}</td>
                              </tr>
                            ))}
                            </tbody>
                        </table>
                        </div>        
                    </div>
                </div>           

            </div>
        </div>

        <div className="card shadow-sm">
            <div className="card-body justify-content-between">
                <div className="d-flex justify-content-between align-items-center mb-2 border-bottom pb-2">
                  <h4 className="mb-0">Others Contribution</h4>
                </div>

                <div className="row">
                    <div className="col-md-12 col-xl-12 col-xxl-12">
                        <div className="table-responsive" style={{ maxHeight: "600px" }}>
                        <table className="table text-nowrap table-bordered">
                            <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                            <tr>
                                <th className="sticky-col-1"></th>
                                <th className="sticky-col-2">Designation</th>
                                <th className="sticky-col-3">Business Delivered</th>
                                <th>Closed Searches</th>
                                <th>Active Roles</th>
                                <th>Active Clients</th>
                                <th>Q1</th>
                                <th>Q2</th>
                                <th>Q3</th>
                                <th>Q4</th>
                                <th>Apr</th>
                                <th>May</th>
                                <th>Jun</th>
                                <th>Jul</th>
                                <th>Aug</th>
                                <th>Sep</th>
                                <th>Oct</th>
                                <th>Nov</th>
                                <th>Dec</th>
                                <th>Jan</th>
                                <th>Feb</th>
                                <th>Mar</th>
                            </tr>
                            </thead>

                            <tbody>
                            {otherOptions.map((row, index) => (
                              <tr>
                                <td className="sticky-col-1">{row.bu_head}</td>
                                <td className="sticky-col-2">{row.designation}</td>
                                <td className="sticky-col-3">{formatNumber(row.revenue)}</td>
                                <td>{row.closed_searches}</td>
                                <td>{row.active_roles}</td>
                                <td>{row.active_clients}</td>
                                <td>{formatNumber(row.Q1)}</td>
                                <td>{formatNumber(row.Q2)}</td>
                                <td>{formatNumber(row.Q3)}</td>
                                <td>{formatNumber(row.Q4)}</td>
                                <td>{formatNumber(row.Apr)}</td>
                                <td>{formatNumber(row.May)}</td>
                                <td>{formatNumber(row.Jun)}</td>
                                <td>{formatNumber(row.Jul)}</td>
                                <td>{formatNumber(row.Aug)}</td>
                                <td>{formatNumber(row.Sep)}</td>
                                <td>{formatNumber(row.Oct)}</td>
                                <td>{formatNumber(row.Nov)}</td>
                                <td>{formatNumber(row.Decr)}</td>
                                <td>{formatNumber(row.Jan)}</td>
                                <td>{formatNumber(row.Feb)}</td>
                                <td>{formatNumber(row.Mar)}</td>
                              </tr>
                            ))}
                            </tbody>
                        </table>
                        </div>        
                    </div>
                </div>
            </div>
        </div>
        </>
    );
}

export default UnitPerformance;